"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = { name: "@video/video-client-web", version: "13.2.0" };
//# sourceMappingURL=package-json.js.map